module.exports = __webpack_public_path__ + "static/img/koko.dddb0a20.png";